import { AxiosResponse, AxiosInstance, AxiosError } from 'axios';
import Handler from '@/core/domain/usecase/handler';

import { ScreenCompany } from '@/module/screen/domain/model/screen_company'

export interface FetchScreenCompanyRepository {
    (id: number): Promise<number[]>
}

const fetchScreenCompanyRepository = (axios: AxiosInstance): FetchScreenCompanyRepository => async (id: number) => {
    try {
        const response: AxiosResponse<ScreenCompany[]> = await axios.get(`/screen-company/${id}`)

        return response.data.map(screen => screen.screenID)
    } catch (err: any | AxiosError) {
        if (err.isAxiosError) {
            throw new Handler().trataErro(err)
        } else {
            throw err
        }
    }
}

export default fetchScreenCompanyRepository
